import React, { useEffect, useState } from "react";

import HTMLDisplay from "./HTMLDisplay";
import { Box, Stack, Typography } from "@mui/material";

const Variability_Html = ({ variabilityData }) => {
  if (!variabilityData.data || variabilityData.length === 0)
    return <Typography>Nothing to display</Typography>;

  return (
    <Stack spacing={1}>
      {variabilityData.map((record, index) => (
        <Box key={`html_${index}`}>
          <HTMLDisplay html={record.data} />;
        </Box>
      ))}
    </Stack>
  );
};

export default Variability_Html;
